// extracted by mini-css-extract-plugin
export var content = "post-module--content--v+Bu0";
export var date = "post-module--date--CYQW4";
export var image = "post-module--image--xNKEP";
export var tags = "post-module--tags--JJDDN";